import { useUiStore } from '../../stores/uiStore.js';
import { TabNav } from './TabNav.js';
import { ProjectDropdown } from '../projects/ProjectDropdown.js';
import { SceneList } from '../scenes/SceneList.js';
import { DayPlanner } from '../days/DayPlanner.js';
import { LocationsPanel } from '../locations/LocationsPanel.js';
import { useMapStore } from '../../stores/mapStore.js';

export function Sidebar() {
  const { sidebarOpen, activeTab, toggleSidebar } = useUiStore();
  const { toggleTraffic, showTraffic, activeProject } = useMapStore();

  return (
    <>
      {/* Toggle button (always visible) */}
      <button
        onClick={toggleSidebar}
        className="absolute top-4 left-4 z-30 bg-white rounded-xl shadow-lg w-9 h-9 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors"
        title={sidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
      >
        {sidebarOpen ? '◀' : '▶'}
      </button>

      {/* Sidebar panel */}
      <aside
        className={`absolute top-0 left-0 h-full z-20 bg-white shadow-xl flex flex-col transition-all duration-200 ${sidebarOpen ? 'w-80' : 'w-0 overflow-hidden'}`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 shrink-0">
          <div className="flex items-center gap-2">
            <span className="text-xl">📍</span>
            <span className="font-bold text-gray-900 text-sm">Location Breaker</span>
          </div>
          <button
            onClick={toggleTraffic}
            title="Toggle traffic layer"
            className={`text-xs px-2 py-1 rounded-lg border transition-colors ${showTraffic ? 'bg-brand-500 text-white border-brand-500' : 'border-gray-200 text-gray-500 hover:border-gray-300'}`}
          >
            🚦
          </button>
        </div>

        {/* Project selector */}
        <ProjectDropdown />

        {/* Tab navigation */}
        <TabNav />

        {/* Tab content */}
        <div className="flex-1 overflow-y-auto p-4">
          {activeTab === 'projects' && <SceneList projectId={activeProject?.id ?? ''} />}
          {activeTab === 'days' && <DayPlanner />}
          {activeTab === 'locations' && <LocationsPanel />}
        </div>
      </aside>
    </>
  );
}
